import { styled } from 'styled-components';
import React from 'react';
import { media } from '@/styles/Qtheme';

export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 18px;

  @media (max-width: 900px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const MissionCard = styled.div`
  background-color: ${({ theme }) => theme.COLORS.tableBg};
  padding: 34px 36px;

  display: flex;
  flex-direction: column;

  @media ${media.mobile} {
    padding: 16px;
  }
`;

export const MissionCardTitle = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  top: -17px;
  left: -17px;

  @media ${media.mobile} {
    top: -12.195px;
    left: -12.195px;
  }
`;

export const MissionCardCoinWrapper = styled.div<{ size?: number }>`
  width: ${({ size }) => (size ? `${size}px` : '122px')};
  height: ${({ size }) => (size ? `${size}px` : '122px')};

  position: relative;

  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const MissionCardCoinImg = styled.img<{ size?: number }>`
  position: absolute;
  left: 0;
  top: 0;
  width: ${({ size }) => (size ? `${size}px` : '100%')};
  height: ${({ size }) => (size ? `${size}px` : '100%')};
  object-fit: cover;
`;

export const MissionCardCoinTextWrapper = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 2px;
`;

export const MissionCardCoinNumber = styled.div`
  font-weight: 800;
  font-size: 28px;
  line-height: 1;

  background: linear-gradient(179.7deg, #feffff 10.72%, #fbeeb8 0.44%), #ffffff;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;

  @media ${media.mobile} {
    font-size: 18px;
  }
`;

export const MissionCardCoinCurrency = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 1;

  background: linear-gradient(
      179.7deg,
      #f1bb3c 84.02%,
      #e98b34 99.45%,
      #e46e2f 109.74%,
      #e1622e 116.17%,
      #d9483d 125.17%,
      #d43946 132.88%,
      #d3344a 139.31%
    ),
    #ffffff;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;

  @media ${media.mobile} {
    font-size: 10px;
  }
`;

export const MissionCardTitleText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const MissionCardTitleTextTitle = styled.div`
  font-size: 22px;
  font-weight: 600;
  color: ${({ theme }) => theme.COLORS.textw};

  @media ${media.mobile} {
    font-size: 16px;
  }
`;

export const MissionCardTitleTextDescription = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: ${({ theme }) => theme.COLORS.sectionDesc};

  @media ${media.mobile} {
    font-size: 14px;
  }
`;

export const MissionCardButton = styled.button<{
  disabled: boolean;
  isDarkMode: boolean;
}>`
  font-family: 'Pretendard', sans-serif;
  width: 100%;
  height: 54px;
  border-radius: 4px;
  border: 1px solid
    ${({ disabled, isDarkMode }) => {
      if (isDarkMode) {
        return disabled ? '#333333' : '#ff5c17';
      } else {
        return disabled ? '#F3E2DD' : '#ff5c17';
      }
    }};
  background-color: ${({ disabled, isDarkMode }) => {
    if (isDarkMode) {
      return disabled ? '#1F1F1F' : 'transparent';
    } else {
      return disabled ? '#EFD6C8' : 'transparent';
    }
  }};
  color: ${({ disabled, theme }) =>
    disabled ? theme.COLORS.textw : '#ff5c17'};
  font-size: 16px;
  font-weight: 500;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

  @media ${media.mobile} {
    height: 42px;
    font-size: 14px;
  }
`;

export const DisabledRewardButton = styled.button`
  margin-top: 6px;
  width: 100%;
  height: 54px;
  padding: 10px;
  border: 1px solid #ff5c17;
  background: transparent;
  color: #ff5c17;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 500;
  font-family: 'Pretendard';
  cursor: pointer;

  @media ${media.mobile} {
    height: 42px;
    font-size: 14px;
  }
`;

export const TimezoneInfoContainer = styled.div<{ isDarkmode: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: 24px;
  padding: 20px 24px;
  background-color: ${({ isDarkmode }) =>
    isDarkmode ? 'rgba(255, 255, 255, 0.03)' : 'rgba(0, 0, 0, 0.02)'};
  border-radius: 8px;

  @media ${media.mobile} {
    margin-top: 16px;
    padding: 16px 20px;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }
`;

export const TimezoneInfoIcon = styled.span`
  font-size: 20px;
  line-height: 1.4;
  opacity: 0.6;
  flex-shrink: 0;

  @media ${media.mobile} {
    font-size: 18px;
  }
`;

export const TimezoneInfoContent = styled.div`
  font-size: 13px;
  font-weight: 400;
  color: ${({ theme }) => theme.COLORS.sectionDesc};
  line-height: 1.8;
  text-align: left;
  white-space: pre-line;
  opacity: 0.8;
  flex: 1;

  @media ${media.mobile} {
    font-size: 12px;
    line-height: 1.6;
    text-align: center;
  }
`;
